
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[channelID]",
      function () {
        return require("private-next-pages/live/[channelID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[channelID]"])
      });
    }
  